import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Checkbox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isChecked: false,
    }
    this.toggleCheckboxChange = this.toggleCheckboxChange.bind(this)
  }

  toggleCheckboxChange() {
    this.setState(({ isChecked }) => (
      {
        isChecked: !isChecked,
      }
    ))

    this.props.handleCheckboxChange(!this.state.isChecked)
  }

  render() {
    const { isChecked } = this.state

    return (
      <div className="ln-c-form-option ln-c-form-option--checkbox">
        <input
          id={`chk${this.props.rowNumber}`}
          className="ln-c-form-option__input"
          type="checkbox"
          checked={isChecked}
          onChange={this.toggleCheckboxChange}
        />
        <label className="ln-c-form-option__label" htmlFor={`chk${this.props.rowNumber}`} />
      </div>
    )
  }
}

Checkbox.propTypes = {
  rowNumber: PropTypes.number.isRequired,
  handleCheckboxChange: PropTypes.func.isRequired
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/Common/Checkbox.jsx